import {
  index as baseIndex,
  getFromId as baseGetFromId,
  editFromId as baseEditFromId,
  newItem as baseNewItem
 } from './Base';

/******************************************************************************
 * INDEX FUNCTION                                                             *
 ******************************************************************************/

/**
 * Get a list of credit packs based on a pagination system
 *
 * @param page the page requested
 * @param itemPerPage the number of item in the page requested
 */
export function index(page = 1, itemPerPage = 10, search = {}, order = 'ASC', scheme = null){
  return baseIndex('credit_packs', page, itemPerPage, search, order, scheme);
}

/******************************************************************************
 * GETTER FUNCTION                                                            *
 ******************************************************************************/

/**
 * Get a single credit pack based on his ID
 *
 * @param id the of the credit pack requested
 */
export function getFromId(id) {
  return baseGetFromId('credit_packs', id);
}

/**
 * Get a single credit pack based on his ID
 *
 * @param id the of the credit pack requested
 */
export function getIdentificationFromId(id) {
  return baseGetFromId('credit_packs', id, 'identification');
}

/**
 * Get a single credit pack based on his ID
 *
 * @param id the of the credit pack requested
 */
export function getPreviousPricesFromId(id) {
  return baseGetFromId('credit_packs', id, 'previous_prices');
}

/******************************************************************************
 * SETTER FUNCTION                                                            *
 ******************************************************************************/

/**
 * Edit a single credit pack based on his ID
 *
 * @param id the of the credit pack requested
 * @param data the new data of the credit pack
 */
export function editFromId(id, data) {
  return baseEditFromId('credit_packs', id, data);
}

/******************************************************************************
 * NEW FUNCTION                                                               *
 ******************************************************************************/

/**
 * Create a new credit pack
 *
 * @param data the new data of the credit pack
 */
export function newItem(data) {
  return baseNewItem('credit_packs', data);
}

/******************************************************************************
 * FETCH FUNCTION                                                             *
 ******************************************************************************/

 /**
  * Fetch all credit packs to serve in a dropdown form choice
  */
 export function fetchCreditPacks() {
   return baseIndex('credit_packs', 1, 0);
 }

/**
 * Fetch all credit packs to serve in a dropdown form choice
 */
export function fetchAvailableCreditPacks() {
  let search = {
    available: true
  }
  return baseIndex('credit_packs', 1, 0, search);
}
